export default (rate, midmarketRate, tolerancePercentage = 0.04) => {
  if (!midmarketRate) {
    return false;
  }
  const lowerBound = midmarketRate - midmarketRate * (tolerancePercentage / 100);
  const upperBound = midmarketRate + midmarketRate * (tolerancePercentage / 100);
  return rate >= lowerBound && rate <= upperBound;
};
